export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';
export const SET_LOGIN_FORM_FIELD = 'SET_LOGIN_FORM_FIELD';
export const LOGIN = 'LOGIN';
export const LOGIN_PENDING = `${LOGIN}_PENDING`;
export const LOGIN_FULFILLED = `${LOGIN}_FULFILLED`;
export const LOGIN_REJECTED = `${LOGIN}_REJECTED`;

export const SET_RETURN_PATH = 'SET_RETURN_PATH';

export const LOAD_IDENTITY = 'LOAD_IDENTITY';
export const LOAD_IDENTITY_FULFILLED = 'LOAD_IDENTITY_FULFILLED';
export const LOAD_IDENTITY_REJECTED = 'LOAD_IDENTITY_REJECTED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_PENDING = `${LOGOUT}_PENDING`;



// WEBPACK FOOTER //
// ./app/features/authentication/actions/types.js